// extracted by mini-css-extract-plugin
export default {"tabs":"TabButtons_tabs__mBbU4","tabWrapper":"TabButtons_tabWrapper__xllq2","tab":"TabButtons_tab__qVGs3","small":"TabButtons_small__kib1A","highlight":"TabButtons_highlight__uhE+x"};